import React, { useState } from "react";
import axiosInstance from "../../axios/axios";
import vozoLogo from "../../assets/images/vozo-logo-1.png";
import axios from "axios";
import { Encrypt_Value, Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { fileurl, DBHost } from "../../axios/url";
import { Select } from "antd";

const { Option } = Select;
const getUserId = () => {
  try {
    const encryptedId = localStorage.getItem("user_id");
    if (!encryptedId) return null;
    return Decrypt_Value(encryptedId, "vozo");
  } catch (e) {
    console.error("User ID decrypt failed", e);
    return null;
  }
};
const completeOnboarding = async () => {
  const userId = getUserId();
  if (!userId) return;

  try {
    const payload = Encrypt_Value({ uid: userId, step: 3 }, "vozo");

    await axiosInstance.post("/vozo/updatepopupstep", payload);
  } catch (err) {
    console.error("Final onboarding update failed", err);
  }
};

const BillingPopupFields = ({ onFinish }) => {
  //   const encryptedUserId = localStorage.getItem("user_id");
  //   const user_id = encryptedUserId
  //     ? Decrypt_Value(encryptedUserId, "vozo")
  //     : null;
  const user_id = getUserId();
  const [form, setForm] = useState({
    currency: "$",
    stripe_publishable_key: "",
    stripe_secret_key: "",
  });

  const [secretValidation, setSecretValidation] = useState(false);
  const [response, setResponse] = useState(false);

  const isBillingValid = () => {
    const pubOk = /^pk_(test|live)_[\w-]+$/.test(
      form.stripe_publishable_key?.trim(),
    );
    const secOk = /^sk_(test|live)_[\w-]+$/.test(
      form.stripe_secret_key?.trim(),
    );

    if (!pubOk || !secOk) return false;

    return true;
  };
  const billingValid = isBillingValid();
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setSecretValidation(false);
    setResponse(false);
  };
  const isValidStripeKeys = () => {
    if (!form.stripe_publishable_key && !form.stripe_secret_key) {
      return true;
    }

    const pubOk = /^pk_(test|live)_[\w-]+$/.test(form.stripe_publishable_key);
    const secOk = /^sk_(test|live)_[\w-]+$/.test(form.stripe_secret_key);

    if (!pubOk || !secOk) {
      setSecretValidation(true);
      setResponse(true);
      return false;
    }

    return true;
  };
  const sec_key_valid = () => {
    return new Promise((resolve, reject) => {
      const body = Encrypt_Value(
        {
          sec_key: form.stripe_secret_key,
          site: DBHost,
        },
        "vozo",
      );

      axios
        .get(fileurl + "/stripe-custom/api_key_validation.php", {
          params: body,
        })
        .then((res) => {
          setResponse(true);
          if (res.data === "success") {
            setSecretValidation(false);
            resolve("passed");
          } else {
            setSecretValidation(true);
            resolve("failed");
          }
        })
        .catch((err) => reject(err));
    });
  };

  const handleSave = async () => {
    try {
      if (!isValidStripeKeys()) return;

      if (form.stripe_secret_key) {
        const result = await sec_key_valid();
        if (result === "failed") return;
      }

      const keys = {
        currency: form.currency,
        StripePublishableKey: form.stripe_publishable_key,
        StripeSecurityKey: form.stripe_secret_key,
        userid: user_id,
      };

      const encryptedKeys = Encrypt_Value(keys, "vozo");

      const formData = new FormData();
      formData.append("keys", encryptedKeys);

      await axiosInstance.post("/vozo/setting/billing", formData);
      await completeOnboarding();
      onFinish();
    } catch (err) {
      console.error("Billing save failed", err);
    }
  };

  return (
    <div className="acp-step acp-billing-step">
      <img src={vozoLogo} alt="VOZO" className="acp-logo" />

      <h3 className="acp-title">Payment made easy</h3>
      <p className="acp-desc">
        Link your Stripe account and accept payments seamlessly
      </p>

      <div className="acp-billing-grid">
        <div>
          <label>Billing Currency</label>
          <Select
            value={form.currency}
            onChange={(val) => setForm({ ...form, currency: val })}
            style={{ width: "100%" }}
          >
            <Option value="$">USD</Option>
            <Option value="C$">CAD</Option>
            <Option value="£">GBP</Option>
          </Select>
        </div>

        <div>
          <label>Stripe Publishable Key</label>
          <input
            name="stripe_publishable_key"
            value={form.stripe_publishable_key}
            onChange={handleChange}
          />
        </div>

        <div>
          <label>Stripe Secret Key</label>
          <input
            name="stripe_secret_key"
            value={form.stripe_secret_key}
            onChange={handleChange}
          />
          <div className="acp-helper">
            Don’t have a Stripe account?{" "}
            <a href="https://stripe.com" target="_blank" rel="noreferrer">
              Click here
            </a>
          </div>
        </div>
      </div>
      {response &&
        (form.stripe_publishable_key || form.stripe_secret_key) &&
        (secretValidation ? (
          <p style={{ color: "#F24822", fontSize: 12 }}>
            Invalid Stripe keys. Enter valid keys.
          </p>
        ) : (
          <p style={{ color: "#138808", fontSize: 12 }}>
            Stripe keys verified successfully
          </p>
        ))}

      <div className="acp-footer">
        <div className="acp-progress-wrap">
          <span className="acp-progress-text">2/2</span>

          <div className="acp-progress-bars">
            <div className="acp-progress-bar">
              <div className="acp-progress-fill filled" />
            </div>

            <div className="acp-progress-bar">
              <div className="acp-progress-fill filled" />
            </div>
          </div>
        </div>

        <div className="acp-actions">
          <button
            className="acp-skip"
            onClick={async () => {
              await completeOnboarding();
              onFinish();
            }}
          >
            Skip for now
          </button>

          <button
            className="acp-save"
            onClick={handleSave}
            disabled={!billingValid}
            style={{
              opacity: billingValid ? 1 : 0.5,
              cursor: billingValid ? "pointer" : "not-allowed",
            }}
          >
            Finish
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillingPopupFields;
